export default {
	MIX: '0',
	ONLY_BUNDLES: '1',
	ONLY_PRESENTATIONS: '2',
	ONLY_CATEGORIES: '3',
	HIGHLIGHT: '4',
}
